import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import API from '@acorn-portal/shared/src/services/AxiosInstance';
import { ReferenceDataClient } from '@acorn-portal/shared/src/services/lookupApi';

export enum ListNames {
	acornCurrentPolicyOptions = 'acornCurrentPolicyOptions',
	additionalDrivingQualifications = 'additionalDrivingQualifications',
	annualTaxiClaimFreeYears = 'annualTaxiClaimFreeYears',
	cancellationReasons = 'cancellationReasons',
	cancelledPolicyTypes = 'cancelledPolicyTypes',
	claimFreeOptions = 'claimFreeOptions',
	claimStatues = 'claimStatues',
	claimType = 'claimType',
	convictionCodes = 'convictionCodes',
	countryEarnedNcdOptions = 'countryEarnedNcdOptions',
	coverLevel = 'coverLevel',
	cvHowManyMonthPolicyWithUsOptions = 'cvHowManyMonthPolicyWithUsOptions',
	deliveryOperators = 'deliveryOperators',
	employmentStatusTypes = 'employmentStatusTypes',
	genders = 'genders',
	hearAboutUsOptions = 'hearAboutUsOptions',
	howManyDaysPolicyWithUsOptions = 'howManyDaysPolicyWithUsOptions',
	howManyMonthPolicyWithUsOptions = 'howManyMonthPolicyWithUsOptions',
	industryTypes = 'industryTypes',
	levelOfCoverTypes = 'levelOfCoverTypes',
	licenceTypes = 'licenceTypes',
	maritalStatusList = 'maritalStatusList',
	medialConditions = 'medialConditions',
	millageIncrementOptions = 'millageIncrementOptions',
	namedDriverLengthOnPolicyOptions = 'namedDriverLengthOnPolicyOptions',
	noClaimsBonusYearsOptions = 'noClaimsBonusYearsOptions',
	noClaimsBonusYearsCurrentAcornPolicy = 'noClaimsBonusYearsCurrentAcornPolicy',
	noClaimsDiscountTypes = 'noClaimsDiscountTypes',
	occupationTypes = 'occupationTypes',
	studentOccupationTypes = 'studentOccupationTypes',
	policyDrivingRestrictions = 'policyDrivingRestrictions',
	relationshipToProposerTypes = 'relationshipToProposerTypes',
	studentCourseTypes = 'studentCourseTypes',
	titlesList = 'titlesList',
	vehicleBodyTypes = 'vehicleBodyTypes',
	vehicleFuelTypes = 'vehicleFuelTypes',
	vehicleKeeperOptions = 'vehicleKeeperOptions',
	vehicleModificationsList = 'vehicleModificationsList',
	vehicleNumberOfDoorsOptions = 'vehicleNumberOfDoorsOptions',
	vehicleOwnershipOptions = 'vehicleOwnershipOptions',
	vehicleSecurityDevices = 'vehicleSecurityDevices',
	vehicleStorageOptions = 'vehicleStorageOptions',
	vehicleTransmissionsTypes = 'vehicleTransmissionsTypes',
	vehicleUseOptions = 'vehicleUseOptions',
	voluntaryExcessOptions = 'voluntaryExcessOptions',
	bodyTypeTypes = 'bodyTypeTypes',
	businessRadius = 'businessRadius',
	licencingArea = 'licencingArea',
}
export interface Option {
	[key: string]: unknown;
}

export const getLists = createAsyncThunk('referenceData/getLists', async (): Promise<Record<string, Array<Option>>> => {
	const service = new ReferenceDataClient(undefined, API);
	const response = await service.getAllReferenceListData();

	return response.referenceData as Record<string, Array<Option>>;
});

const initialState: Record<ListNames, Array<Option>> = {
	acornCurrentPolicyOptions: [],
	additionalDrivingQualifications: [],
	annualTaxiClaimFreeYears: [],
	bodyTypeTypes: [],
	businessRadius: [],
	cancellationReasons: [],
	cancelledPolicyTypes: [],
	claimFreeOptions: [],
	claimStatues: [],
	claimType: [],
	convictionCodes: [],
	countryEarnedNcdOptions: [],
	coverLevel: [],
	cvHowManyMonthPolicyWithUsOptions: [],
	deliveryOperators: [],
	employmentStatusTypes: [],
	genders: [],
	hearAboutUsOptions: [],
	howManyDaysPolicyWithUsOptions: [],
	howManyMonthPolicyWithUsOptions: [],
	industryTypes: [],
	levelOfCoverTypes: [],
	licenceTypes: [],
	licencingArea: [],
	maritalStatusList: [],
	medialConditions: [],
	millageIncrementOptions: [],
	namedDriverLengthOnPolicyOptions: [],
	noClaimsBonusYearsCurrentAcornPolicy: [],
	noClaimsBonusYearsOptions: [],
	noClaimsDiscountTypes: [],
	occupationTypes: [],
	policyDrivingRestrictions: [],
	relationshipToProposerTypes: [],
	studentCourseTypes: [],
	studentOccupationTypes: [],
	titlesList: [],
	vehicleBodyTypes: [],
	vehicleFuelTypes: [],
	vehicleKeeperOptions: [],
	vehicleModificationsList: [],
	vehicleNumberOfDoorsOptions: [],
	vehicleOwnershipOptions: [],
	vehicleSecurityDevices: [],
	vehicleStorageOptions: [],
	vehicleTransmissionsTypes: [],
	vehicleUseOptions: [],
	voluntaryExcessOptions: [],
};

export const referenceDataSlice = createSlice({
	name: 'referenceData',
	initialState,
	reducers: {},
	extraReducers: (builder) => {
		builder.addCase(getLists.pending, () => {});
		builder.addCase(getLists.fulfilled, (state, { payload }) => {
			return {
				...state,
				...payload,
			};
		});
		builder.addCase(getLists.rejected, () => {});
	},
});

export default referenceDataSlice.reducer;
